import "../styles/HomeNew.css";

// ── Data ─────────────────────────────────────────────────────────────────────

const COMMITTEES = [
  {
    title: "Advisory Council",
    color: "card--purple",
    chipClass: "lchip--purple",
    emoji: "🌟",
    members: [
      { name: "Adrian Barr", image: "/images/board-committees/Contact.png" },
      { name: "Dr. Bhanu Vakkalanka", image: "/images/board-committees/Contact.png" },
      { name: "Brian Peterson", image: "/images/board-committees/Contact.png" },
      { name: "Chemberly Harris", image: "/images/board-committees/Contact.png" },
      { name: "Christine Holmes", image: "/images/board-committees/Contact.png" },
      { name: "Dr. Dakesa Pina", image: "/images/board-committees/Contact.png" },
      { name: "David Taylor", image: "/images/board-committees/Contact.png" },
      { name: "Dayna Brown", image: "/images/board-committees/Contact.png" },
      { name: "Dev Mandhyan", image: "/images/board-committees/Contact.png" },
      { name: "Gina Lavazza", image: "/images/board-committees/Contact.png" },
      { name: "Harry Campbell", image: "/images/board-committees/Contact.png" },
      { name: "Julie Emig", image: "/images/board-committees/Contact.png" },
      { name: "Karen Schmidt", image: "/images/board-committees/Contact.png" },
      { name: "Mark Clinch", image: "/images/board-committees/Contact.png" },
      { name: "Meta Mickens Baker", image: "/images/board-committees/Contact.png" },
      { name: "Pretty Reji", image: "/images/board-committees/Contact.png" },
      { name: "Sunil Oberoi", image: "/images/board-committees/Contact.png" },
      { name: "Vani Prasad", image: "/images/board-committees/Contact.png" },
    ],
  },
  {
    title: "Kite Fest Steering Committee",
    color: "card--pink",
    chipClass: "lchip--pink",
    emoji: "🪁",
    members: [
      { name: "Chandra Chaganti", image: "/images/board-committees/Contact.png" },
      { name: "Hariharan Senthilnathan", image: "/images/board-committees/Hari.jpg" },
      { name: "Karthik Goteti", image: "/images/board-committees/Contact.png" },
      { name: "Nirmal Jain", image: "/images/board-committees/Contact.png" },
      { name: "Punitha McCormick", image: "/images/board-committees/Contact.png" },
      { name: "Sambasivarao Gurijala (Co-Chair)", image: "/images/board-committees/Contact.png" },
      { name: "Susmita Lahiri", image: "/images/board-committees/Contact.png" },
      { name: "Venkateswara Rao Mandava (Co-Chair)", image: "/images/board-committees/Mandava.jpg" },
    ],
  },
  {
    title: "Finance Committee",
    color: "card--green",
    chipClass: "lchip--green",
    emoji: "💰",
    members: [
      { name: "Phani Aytam", image: "/images/board-committees/Phani.jpg" },
      { name: "Raja Ayyapusetty", image: "/images/board-committees/Raja.jpg" },
    ],
  },
  {
    title: "Project Recruitment Committee",
    color: "card--purple",
    chipClass: "lchip--purple",
    emoji: "🔍",
    members: [
      { name: "Adrian Barr", image: "/images/board-committees/Contact.png" },
      { name: "Claire Campbell (Chair)", image: "/images/board-committees/ClaireCampbell.jpg" },
      { name: "Christine Holmes", image: "/images/board-committees/Contact.png" },
      { name: "Dane Myers", image: "/images/board-committees/Contact.png" },
      { name: "Vasudha Gadhiraju", image: "/images/board-committees/VasudhaPinnamaraju.jpg" },

    ],
  },
  {
    title: "Giving Committee",
    color: "card--pink",
    chipClass: "lchip--pink",
    emoji: "🤲",
    members: [
      { name: "Phani Aytam", image: "/images/board-committees/Phani.jpg" },
      { name: "Raja Ayyapusetty", image: "/images/board-committees/Raja.jpg" },
      { name: "Venkateswara Mandava", image: "/images/board-committees/Mandava.jpg" },
    ],
  },
  {
    title: "Marketing and Technology Committee",
    color: "card--green",
    chipClass: "lchip--green",
    emoji: "💻",
    members: [
      { name: "Hariharan Senthilnathan", image: "/images/board-committees/Hari.jpg" },
      { name: "Rahul Varun Balivada", image: "/images/board-committees/Rahul.jpg" },
      { name: "Laasya Ayyapusetty (Intern)", image: "/images/board-committees/Contact.png" },
      { name: "Pranika Kurella (Intern)", image: "/images/board-committees/Contact.png" },
      { name: "Rhea Balakrishnan (Intern)", image: "/images/board-committees/Contact.png" },
      { name: "Rishabh Narendranath (Intern)", image: "/images/board-committees/Contact.png" },
      { name: "Srinidhi Gurijala (Intern)", image: "/images/board-committees/Contact.png" },
      { name: "Vishu Devari (Intern)", image: "/images/board-committees/Contact.png" },
    ],
  },
  {
    title: "Youth Global Citizen (YGC) Committee",
    color: "card--purple",
    chipClass: "lchip--purple",
    emoji: "🌱",
    members: [
      { name: "Chemberly Harris", image: "/images/board-committees/Contact.png" },
      { name: "Lance Scray", image: "/images/board-committees/Contact.png" },
      { name: "Shriyans Gurijala", image: "/images/board-committees/Contact.png" },
      { name: "Siddhi Hindurao (Chair)", image: "/images/board-committees/SiddhiHindurao.jpg" },
      { name: "Vedha Giriprakash", image: "/images/board-committees/Contact.png" },
    ],
  },
  {
    title: "Why I See You (YICU) Steering Committee",
    color: "card--pink",
    chipClass: "lchip--pink",
    emoji: "🏆",
    members: [
      { name: "Carolyn Hansen", image: "/images/board-committees/Contact.png" },
      { name: "Dr. Carla Campbell Jackson", image: "/images/board-committees/Contact.png" },
      { name: "Hari Senthilnathan", image: "/images/board-committees/Contact.png" },
      { name: "Hema Kasturi", image: "/images/board-committees/Contact.png" },
      { name: "Kathy Weinzierl (Chair)", image: "/images/board-committees/Kathy.jpg" },
      { name: "Shriyans Gurijala", image: "/images/board-committees/Contact.png" },
      { name: "Sky Holland", image: "/images/board-committees/Contact.png" },
      { name: "Vedha Giriprakash,", image: "/images/board-committees/Contact.png" },
    ],
  },
  {
    title: "STEAM Olympics Steering Committee",
    color: "card--green",
    chipClass: "lchip--green",
    emoji: "🔬",
    members: [
      { name: "Abarnaa Balakrishnan", image: "/images/board-committees/Contact.png" },
      { name: "Akhila Vedam (Co-Chair)", image: "/images/board-committees/Contact.png" },
      { name: "April Eckhardt", image: "/images/board-committees/Contact.png" },
      { name: "Dr. Dakesa Pina", image: "/images/board-committees/Contact.png" },
      { name: "Dhara Shah", image: "/images/board-committees/Contact.png" },
      { name: "Hariharan Senthilnathan", image: "/images/board-committees/Contact.png" },
      { name: "Ivan Lavazza", image: "/images/board-committees/Contact.png" },
      { name: "Dr. Libby Haywood", image: "/images/board-committees/Contact.png" },
      { name: "Josiah Moses", image: "/images/board-committees/Contact.png" },
      { name: "Krishna Sundaram", image: "/images/board-committees/Contact.png" },
      { name: "Mahesh Chandrappa", image: "/images/board-committees/Contact.png" },
      { name: "Meghan Goldfarb", image: "/images/board-committees/Contact.png" },
      { name: "Nundhini Ravi", image: "/images/board-committees/Contact.png" },
      { name: "Payal Sheth", image: "/images/board-committees/Contact.png" },
      { name: "Rahul Varun Balivada", image: "/images/board-committees/Contact.png" },
      { name: "Raja Ayyapusetty", image: "/images/board-committees/Raja.jpg" },
      { name: "Radhika Ayyapusetty", image: "/images/board-committees/Contact.png" },
      { name: "Sabrina Weislak", image: "/images/board-committees/Contact.png" },
      { name: "Sambasivarao Gurijala (Co-Chair)", image: "/images/board-committees/Sam-G.jpg" },
      { name: "Sarita Desale", image: "/images/board-committees/Contact.png" },
      { name: "Sirisha Askana", image: "/images/board-committees/Contact.png" },
      { name: "Sirisha Rani Kamineni", image: "/images/board-committees/Contact.png" },
      { name: "Surekha Methuku", image: "/images/board-committees/Contact.png" },
      { name: "Susmita Korade", image: "/images/board-committees/Contact.png" },
      { name: "Susmita Lahiri", image: "/images/board-committees/Contact.png" },
      { name: "Dr. Taren Nance", image: "/images/board-committees/Contact.png" },
      { name: "Venkat Chander", image: "/images/board-committees/Contact.png" },
      { name: "Vishal Midha", image: "/images/board-committees/Contact.png" },
    ],
  },

];

// ── Member pill ───────────────────────────────────────────────────────────────

function MemberPill({ member, chipClass }) {
  const isChair = member.name.toLowerCase().includes("chair") || member.name.toLowerCase().includes("intern");
  return (
    <div style={{
      display: "flex",
      alignItems: "center",
      gap: ".55rem",
      padding: ".45rem .7rem",
      background: "var(--white)",
      border: "1.5px solid var(--bdr)",
      borderRadius: "100px",
      transition: "border-color .15s, box-shadow .15s",
    }}
      onMouseEnter={e => {
        e.currentTarget.style.borderColor = "var(--pu-200)";
        e.currentTarget.style.boxShadow = "0 2px 12px rgba(124,58,237,.08)";
      }}
      onMouseLeave={e => {
        e.currentTarget.style.borderColor = "var(--bdr)";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      <div style={{
        width: 28, height: 28,
        borderRadius: "50%",
        overflow: "hidden",
        flexShrink: 0,
        background: "var(--bdr)",
      }}>
        <img
          src={member.image}
          alt=""
          width={28} height={28}
          loading="lazy"
          style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
          onError={e => (e.target.style.opacity = 0)}
        />
      </div>
      <span style={{ fontSize: ".83rem", fontWeight: 600, color: "var(--ink)", whiteSpace: "nowrap" }}>
        {member.name}
      </span>
    </div>
  );
}

// ── Committee card ────────────────────────────────────────────────────────────

function CommitteeCard({ committee }) {
  const borderColor =
    committee.chipClass === "lchip--purple" ? "var(--pu-200)"
      : committee.chipClass === "lchip--pink" ? "var(--pk-200)"
        : "var(--gn-200)";
  const bgColor =
    committee.chipClass === "lchip--purple" ? "var(--pu-50)"
      : committee.chipClass === "lchip--pink" ? "var(--pk-50)"
        : "var(--gn-50)";

  return (
    <div style={{
      background: "var(--white)",
      border: `1.5px solid var(--bdr)`,
      borderRadius: "18px",
      overflow: "hidden",
      transition: "border-color .2s, box-shadow .2s, transform .2s",
    }}
      onMouseEnter={e => {
        e.currentTarget.style.borderColor = borderColor;
        e.currentTarget.style.boxShadow = "0 8px 32px rgba(0,0,0,.07)";
        e.currentTarget.style.transform = "translateY(-3px)";
      }}
      onMouseLeave={e => {
        e.currentTarget.style.borderColor = "var(--bdr)";
        e.currentTarget.style.boxShadow = "none";
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      {/* Header */}
      <div style={{
        background: bgColor,
        borderBottom: `1.5px solid ${borderColor}`,
        padding: "1.1rem 1.4rem",
        display: "flex",
        alignItems: "center",
        gap: ".75rem",
      }}>
        <span style={{ fontSize: "1.4rem" }}>{committee.emoji}</span>
        <div>
          <h3 style={{
            fontFamily: "var(--ff-head)",
            fontSize: "1rem",
            fontWeight: 800,
            color: "var(--ink)",
            lineHeight: 1.2,
          }}>
            {committee.title}
          </h3>
          <span className={`lcard__chip ${committee.chipClass}`} style={{ fontSize: ".6rem", marginTop: ".3rem", display: "inline-block" }}>
            {committee.members.length} member{committee.members.length !== 1 ? "s" : ""}
          </span>
        </div>
      </div>

      {/* Members */}
      <div style={{
        padding: "1rem 1.2rem 1.2rem",
        display: "flex",
        flexWrap: "wrap",
        gap: ".5rem",
      }}>
        {committee.members.map(m => (
          <MemberPill key={m.name} member={m} chipClass={committee.chipClass} />
        ))}
      </div>
    </div>
  );
}

// ── Page ─────────────────────────────────────────────────────────────────────

export default function Committee() {
  const totalMembers = [...new Set(COMMITTEES.flatMap(c => c.members.map(m => m.name.replace(/ \(.*\)/, ""))))].length;

  return (
    <div className="pg">

      {/* ── HERO ── */}
      <section className="hero" style={{ minHeight: "40svh" }}>
        <div className="hero__glow hero__glow--1" />
        <div className="hero__glow hero__glow--2" />
        <div className="hero__glow hero__glow--3" />
        <div className="hero__inner" style={{ gridTemplateColumns: "1fr auto" }}>
          <div className="hero__text">
            <p className="hero__kicker">For A Better Tomorrow</p>
            <h1 className="hero__h1">
              Advisors &<br />
              <span className="hero__accent">Committees</span>
            </h1>
            <p className="hero__sub">
              Meet the dedicated volunteers who power every FBT initiative —
              from Kite Fest and YICU to STEAM Olympics and Youth Global Citizen.
            </p>
            <div className="hero__ctas">
              <a href="/board" className="cta cta--solid">Meet the Board</a>
              <a href="#committees" className="cta cta--ghost">View Committees ↓</a>
            </div>
          </div>
          <div className="hero__stats">
            <div className="hstat hstat--purple">
              <span className="hstat__n">{COMMITTEES.length}</span>
              <span className="hstat__l">Committees</span>
            </div>
            <div className="hstat hstat--pink">
              <span className="hstat__n">{totalMembers}+</span>
              <span className="hstat__l">Volunteers</span>
            </div>
            <div className="hstat hstat--green">
              <span className="hstat__n">100%</span>
              <span className="hstat__l">Volunteer-Run</span>
            </div>
          </div>
        </div>
      </section>

      {/* ── COMMITTEES GRID ── */}
      <section id="committees" className="local" style={{ maxWidth: "var(--max)", marginInline: "auto" }}>
        <div className="sec-hd">
          <span className="sec-eye">Our Teams</span>
          <h2 className="sec-h2">Committees & Advisors</h2>
          <p className="sec-sub">
            Each committee drives a specific part of FBT's mission — all run by passionate community volunteers.
          </p>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(340px, 1fr))", gap: "1.25rem" }}>
          {COMMITTEES.map(c => (
            <CommitteeCard key={c.title} committee={c} />
          ))}
        </div>
      </section>

    </div>
  );
}